export const getInfoForGroupRadioButtons = isDisabled => {
  return [{
    value: 'summaryStatistics',
    name: 'datasetContains',
    labelClassName: 'mr-10',
    label: 'Summary Statistics',
    isDisabled
  }, {
    value: 'rawData',
    name: 'datasetContains',
    label: 'Raw Data',
    isDisabled
  }];
};
